<template>
  <template v-for="(part, index) in parts" :key="index">
    <AiAskTerm v-if="part.kind === 'ask'" />
    <AiViewTerm v-else-if="part.kind === 'view'" :plural="part.text === 'Views'" />
    <ArchiveTerm v-else-if="part.kind" :kind="part.kind" />
    <template v-else>{{ part.text }}</template>
  </template>
</template>
<script>
import AiAskTerm from './AiAskTerm.vue';
import AiViewTerm from './AiViewTerm.vue';
import ArchiveTerm from './ArchiveTerm.vue';
export default {
  name: 'ArchiveTermText',
  components: { AiAskTerm, AiViewTerm, ArchiveTerm },
  props: { text: { type: String, required: true } },
  computed: {
    parts() {
      return this.text.split(/\b(Search|Ask|Views?|Gallery)\b/).map(text => ({
        text,
        kind: /^(Search|Ask|Views?|Gallery)$/.test(text) ? text.toLowerCase().replace(/^views$/, 'view') : '',
      }));
    },
  },
};
</script>
